import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VIEW_SMOOTH } from "../../util/varibles/constants";
import { getElById, showErrorResponse } from "../../util/varibles/global";
import { IPois, IRoute } from "../../util/varibles/interface";
import { initialState, RouteMode } from "./constatns";

const routeSlice = createSlice({
    name: 'route',
    initialState,
    reducers: {
        initialDataRequest: (state, action) => {
            const { locations } = state;
            const { source_id, destination_id } = action.payload;
            const source = locations.find(item => item.id === source_id);
            const destination = locations.find(item => item.id === destination_id);
            state.params = { ...state.params, ...action.payload, source, destination };
            state.loading = { ...state.loading, routes: true };
            state.routes = [];
        },
        initialDataSuccess: (state, action) => {
            const routes = action.payload
            state.routes = routes.sort((a: any, b: any) => a.name.localeCompare(b.name));
            state.showId = state.routes.findIndex(item => item.default) || 0
            state.route = routes[0];
            state.loading = { ...state.loading, routes: false };
        },
        initialDataFailure: (state) => {
            state.loading = { ...state.loading, routes: false }
        },
        show: (state, action) => {
            state.showId = action.payload;
        },
        changeMode: (state, action) => {
            const { mode, route } = action.payload;
            state.mode = mode;
            if (route)
                state.route = route;
        },
        editRoute: (state, action) => {
            state.route = action.payload
        },
        addRoute: (state, action) => {
            const route = action.payload
            const { routes } = state;
            const { source, destination } = state.params;
            const routeNew = { ...route, source, destination };
            if (route.default)
                state.routes = state.routes.map(x => ({ ...x, default: false }));

            state.showId = state.routes.length;
            state.route = route;
            state.routes = [...routes, routeNew];
            state.mode = RouteMode.VIEW;
        },
        updateRoute: (state, action) => {
            const route = action.payload
            const { routes } = state;
            const { source, destination } = state.params;
            const routeNew = { ...route, source, destination };
            let showId = 0;
            let forward = route.default ? (x: IRoute) => ({ ...x, default: false }) : (x: IRoute) => x
            state.route = route;
            state.routes = routes.map((item, i) => {
                if (item.id === route.id) {
                    showId = i;
                    return routeNew;
                }
                return forward(item)
            });
            state.mode = RouteMode.VIEW;
            state.showId = showId;
        },
        updatePoint: (state, action: PayloadAction<{
            marker: { latitude: number, longitude: number },
            position?: number,
            isDelete?: boolean
        }>) => {
            const { marker, position, isDelete = false } = action.payload
            const points = Array.from([...state.route?.points || []]);
            const index = position || points.length - 1;
            setTimeout(() => {
                const el = getElById(`position_${index}`);
                if (el)
                    el.scrollIntoView(VIEW_SMOOTH)
            }, 100)
            points.splice(index, isDelete ? 1 : 0, marker);
            state.route = { ...state.route, points } as IRoute;
        },
        updateDefault: (state, action) => {
            const routeId = action.payload;
            const { routes } = state;
            state.routes = routes.map((item: any) => ({ ...item, default: item.id === routeId }))
        },
        deleteRoute: (state, action) => {
            const routeId = action.payload;
            const { routes } = state;
            state.routes = routes.filter((item: any) => item.id !== routeId)
        },
        changeShowAll: (state) => {
            state.isShowAll = !state.isShowAll
        },
        updateParams: (state, action) => {
            state.routes = [];
            state.params = action.payload
        },
        getLocationsRequest: (state) => {
            state.loadingLocations = true;
        },
        getLocationsSuccess: (state, action: PayloadAction<IPois[]>) => {
            const locations = action.payload;
            const { source_id, destination_id } = state.params;
            const source = locations.find(item => item.id === source_id);
            const destination = locations.find(item => item.id === destination_id);
            state.params = { ...state.params, source, destination };
            state.loadingLocations = false;
            state.locations = locations;
        },
        getLocationsFailure: (state) => {
            state.loadingLocations = false
        },
        autoRouteRequest: (state, action) => {
            const { request_id } = action.payload;
            state.requestId = request_id;
            state.loadingAuto = true;
        },
        autoRouteSuccess: (state, action) => {
            const data = action.payload;
            const { requestId = '', route = {} } = state;
            if (data.request_id === requestId) {
                if (data.status === 200) {
                    state.route = { ...route, points: data.path, route_mode: 'auto' } as IRoute
                } else {
                    showErrorResponse('Auto route failure', data.message);
                }
                state.loadingAuto = false;
                state.requestId = '-';
            }
        },
        autoRouteFailure: (state, action) => {
            if (action.payload.message)
                showErrorResponse('Auto route failure', action.payload);
            state.loadingAuto = false;
            state.requestId = '-';
        },
        reset: () => initialState
    },
})

export const routeActions = routeSlice.actions

const routeReducer = routeSlice.reducer;

export default routeReducer;
